import email from '../images/email.png';
import wp from '../images/Wordpress.png';
import api from '../images/api.png';
import adobeP from '../images/AP.png';
import css from '../images/css.png';
import figma from '../images/figma.png';
import adobeI from '../images/AI.png';
import git from '../images/git.png';
import mongo from '../images/mongo.png';
import html from '../images/html.png';
import javascript from '../images/javascript.png';
import mu5 from '../images/mu5.png';
import node from '../images/node.png';
import python from '../images/python.png';
import react from '../images/react.png';
import redux from '../images/redux.png';
import sass from '../images/sass.png';
import postgre from '../images/Postgre.png';
import sanity from '../images/sanity.png';
import solidity from '../images/Solidity.png';
import tailwind from '../images/tailwind.png';
import next from '../images/next.svg';
import shopify from '../images/shopify.png';


import about01 from '../images/about01.jpeg';
import about02 from '../images/about02.jpeg';
import about03 from '../images/about03.jpeg';
import about04 from '../images/about04.png';

import profile from '../images/dp.png';
import circle from '../images/circle.svg';
import logo from '../images/logo.png';
import eth from '../images/eth.png';
import mobile from '../images/mobile.png';



export default {
  email,
  wp,
  api,
  eth,
  css,
  figma,
  postgre,
  git,
  next,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  mongo,
  solidity,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  sanity,
  shopify,
  adobeI,
  adobeP,
  tailwind,
  mobile,
};